import React from 'react';
import '../assets/css/dark-theme.css';

const Features = () => (
    <section className="features-section-dark">
        <div className="container" id="how_it_works">
            <div className="section-title-dark">
                <h2>Our Seamless Loan Process</h2>
            </div>
            <div className="row">
                <div className="col-md-6 col-lg-3 mb-4">
                    <div className="feature-card-dark">
                        <div className="card-icon-dark">
                            <i className="fas fa-desktop"></i>
                        </div>
                        <div className="card-content-dark">
                            <h3>1. Send Enquiry</h3>
                            <p>Call us or fill an application form online to begin your commercial EV journey.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 mb-4">
                    <div className="feature-card-dark">
                        <div className="card-icon-dark">
                            <i className="fas fa-cloud-upload-alt"></i>
                        </div>
                        <div className="card-content-dark">
                            <h3>2. Upload Docs</h3>
                            <p>Securely upload your scanned documents for fast, digital processing.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 mb-4">
                    <div className="feature-card-dark">
                        <div className="card-icon-dark">
                            <i className="fas fa-clipboard-check"></i>
                        </div>
                        <div className="card-content-dark">
                            <h3>3. Quick Verification</h3>
                            <p>Undergo a lightning-fast eKYC and video verification process.</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-3 mb-4">
                    <div className="feature-card-dark">
                        <div className="card-icon-dark">
                            <i className="fas fa-key"></i>
                        </div>
                        <div className="card-content-dark">
                            <h3>4. Loan Sanction</h3>
                            <p>Get immediate approval and fast disbursement straight into your account.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Features;



// WEBPACK FOOTER //
// ./src/components/Features.js